import * as Types from "../../../../../generated/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type JobsCitiesQueryVariables = Types.Exact<{
  limit: Types.Scalars["Float"];
  offset: Types.Scalars["Float"];
  query: Types.Scalars["String"];
}>;

export type JobsCitiesQuery = {
  __typename?: "Query";
  jobsCities: {
    __typename?: "EntitiesWithCountForSelect";
    count: number;
    entities: Array<{ __typename?: "Entity"; id: string; name: string }>;
  };
};

export const JobsCitiesDocument = gql`
  query JobsCities($limit: Float!, $offset: Float!, $query: String!) {
    jobsCities(limit: $limit, offset: $offset, query: $query) {
      entities {
        id
        name
      }
      count
    }
  }
`;

/**
 * __useJobsCitiesQuery__
 *
 * To run a query within a React component, call `useJobsCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsCitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useJobsCitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    JobsCitiesQuery,
    JobsCitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<JobsCitiesQuery, JobsCitiesQueryVariables>(
    JobsCitiesDocument,
    options
  );
}
export function useJobsCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JobsCitiesQuery,
    JobsCitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<JobsCitiesQuery, JobsCitiesQueryVariables>(
    JobsCitiesDocument,
    options
  );
}
export type JobsCitiesQueryHookResult = ReturnType<typeof useJobsCitiesQuery>;
export type JobsCitiesLazyQueryHookResult = ReturnType<
  typeof useJobsCitiesLazyQuery
>;
export type JobsCitiesQueryResult = Apollo.QueryResult<
  JobsCitiesQuery,
  JobsCitiesQueryVariables
>;
